// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".system h2 {\n  padding: 10px;\n  margin: 10px 0;\n  font-size: 16px;\n  -webkit-box-shadow: -4px 1px 3px 0px #e7e8e8;\n          box-shadow: -4px 1px 3px 0px #e7e8e8;\n}", ""]);
// Exports
module.exports = exports;
